import { render, staticRenderFns } from "./ChooseSubjectSecond.vue?vue&type=template&id=5fa55700&scoped=true&"
import script from "./ChooseSubjectSecond.vue?vue&type=script&lang=js&"
export * from "./ChooseSubjectSecond.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSubjectSecond.vue?vue&type=style&index=0&id=5fa55700&scoped=true&lang=less&"
import style1 from "./ChooseSubjectSecond.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa55700",
  null
  
)

export default component.exports